import { Link } from './link.model'

export class Seatingplan {
	public storageId: string
	public uuid: string
	public name: string
	public merchantId: string
	public isInUse: boolean
	public _links: {
		self: Link
	}
}



// WEBPACK FOOTER //
// ./src/app/models/seatingplan.model.ts